/**
 * @generated SignedSource<<d96333e8842b0151b4aa08264d44f0d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NotificationProviderNotificationChangesQuery$variables = {};
export type NotificationProviderNotificationChangesQuery$data = {
  readonly lastNotificationCreatedAt: any | null;
};
export type NotificationProviderNotificationChangesQuery = {
  response: NotificationProviderNotificationChangesQuery$data;
  variables: NotificationProviderNotificationChangesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastNotificationCreatedAt",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationProviderNotificationChangesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationProviderNotificationChangesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1bc68095c3390b41c144b6191fb3aee7",
    "id": null,
    "metadata": {},
    "name": "NotificationProviderNotificationChangesQuery",
    "operationKind": "query",
    "text": "query NotificationProviderNotificationChangesQuery {\n  lastNotificationCreatedAt\n}\n"
  }
};
})();

(node as any).hash = "011436cd71602ffb2e5e1aa2901b4837";

export default node;
